module.exports = __webpack_public_path__ + "static/media/Mrinalini5.176ba218.jpg";